import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Appbar, Chat, SendContractModal, TutorialsModal } from '../../design-system';
import { DashboardBase, DashboardMain, DashboardWrapper } from './DashboardComponents';
import { DashboardDrawer } from './DashboardDrawer';
import { DashboardBottomNavigation } from './DashboardBottomNavigation';
import { NotificationsDrawer } from '../notifications';
import { useStore } from '../../context';
import { showToRoles, showToRolesMobile } from '../../utils';
import { useIsSmallScreen } from '../../hooks';

export const Dashboard = () => {
  const {
    state: {
      refreshPage,
      user: { data: user },
    },
  } = useStore();
  const isSmallScreen = useIsSmallScreen();
  const pagename = window.location.pathname.split('/').pop();
  const [openDrawer, setOpenDrawer] = useState(
    typeof localStorage.getItem('dashboard-drawer') === 'string'
      ? localStorage.getItem('dashboard-drawer')
      : '',
  );

  const handleChangeDrawer = (drawer: 'dashboard' | 'notifications' | '') => {
    if (openDrawer === drawer) {
      drawer = '';
    }

    setOpenDrawer(drawer);
    localStorage.setItem('dashboard-drawer', drawer);
  };

  return (
    <>
      <DashboardWrapper showBottomNavigation={showToRolesMobile(['TRADER'], user, true)}>
        <DashboardBase>
          <DashboardDrawer
            isOpen={openDrawer === 'dashboard'}
            handleChangeDrawer={() => handleChangeDrawer('dashboard')}
          />
          <Appbar
            handleChangeDrawer={(drawer: any) => handleChangeDrawer(drawer || 'notifications')}
          />
          <DashboardMain id={'dashboard-main'} key={refreshPage} pagename={pagename}>
            <Outlet />
          </DashboardMain>
          <NotificationsDrawer
            isOpen={openDrawer === 'notifications'}
            handleChangeDrawer={() => handleChangeDrawer('notifications')}
          />
        </DashboardBase>
        {showToRolesMobile(['TRADER'], user, isSmallScreen) && (
          <DashboardBottomNavigation visible={openDrawer === ''} />
        )}
      </DashboardWrapper>
      <SendContractModal />
      <TutorialsModal />
      {showToRoles(['SUPER_ADMIN', 'CLIENT_MANAGER', 'CLIENT_DISPATCHER'], user) && <Chat />}
    </>
  );
};
